import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import {
  IDashboardFolderCreateMutation,
  IDashboardFolderCreateMutationVariables,
  IDashboardFolderFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import printGraphqlErrors from '../../../utils/apollo/printGraphqlErrors';
import { assertNotNil } from '../../../utils/types';
import { DASHBOARD_FOLDER_CREATE } from '../../../utils/apollo/dashboards';

const useCreateFolder = ({
  parentFolderId,
  onSubmit,
  onError,
}: {
  parentFolderId: string | null;
  onSubmit: (newFolder: IDashboardFolderFieldsFragment) => void;
  onError?: () => void;
}) => {
  const handleComplete = ({
    dashboardFolderCreate,
  }: IDashboardFolderCreateMutation) => {
    const { entity, errors } = dashboardFolderCreate;

    if (printGraphqlErrors(errors)) {
      onError?.();
      return;
    }

    assertNotNil(entity);
    onSubmit(entity);
  };

  const [dashboardFolderCreate] = useMutation<
    IDashboardFolderCreateMutation,
    IDashboardFolderCreateMutationVariables
  >(DASHBOARD_FOLDER_CREATE, {
    onCompleted: handleComplete,
  });

  return useCallback(
    (newFolderName: string) => {
      dashboardFolderCreate({
        variables: {
          input: {
            name: newFolderName,
            parentId: parentFolderId,
          },
        },
      });
    },
    [dashboardFolderCreate, parentFolderId],
  );
};

export default useCreateFolder;
